module.exports = __webpack_public_path__ + "img/clothing88.598c53f5.jpg";